const translations = {
    'tier.city': 'City',
    'tier.outpost': 'Outpost',
    'tier.town': 'Town',
};

export default translations;
